// extracted by mini-css-extract-plugin
export default {"view-switch":"SwitchViewDropdown_view-switch__jZQod"};